'use strict';
import {ROOT_API_COLLECTION, ROOT_API_SPEC} from '../../config/constants';
import {getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {getOrganization, getUser} from '../../app/model/reducers/state';


export function DataTagDomainProvider() {
  return {
    $get: [
      '$injector',
      '$ngRedux',
      'FirebaseUtil',
      'FirebaseConnectionService',
      'AbstractDomainClass',
      'OrgMixin',
      'FirebaseQueueService',
      'DomainUtils',
      function (
        $injector,
        $ngRedux,
        FirebaseUtil,
        FirebaseConnectionService,
        AbstractDomainClass,
        OrgMixin,
        FirebaseQueueService,
        DomainUtils,
      ) {
        function DataTagDomain(data) {
          AbstractDomainClass.call(this, DataTagDomain, data);
        }

        AbstractDomainClass.__inheritFrom(DataTagDomain, 'DataTagDomain', 'data-tags');

        /* appliesTo:
         * Stores an optional white-list of collection this tag may be applied to.
         * Useful for limiting the number of available tags that show up in each context to keep from being overwhelmed.
         *
         * Currently recommending using this aggressively to keep choices limited to relevant tags for
         * projects, tasks, assets, people, etc
         */

        DataTagDomain.$constraints.addConstraints({
          name: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          form: {type: 'Domain', domainClass: 'FormDomain', nullable: true, simpleLink: true},
          appliesTo: {type: 'JSON', stringify: true, nullable: true},
          organization: {type: 'DomainLink', domainClass: 'OrganizationDomain', links: 'data-tags', belongsTo: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          tagged: {type: 'DomainCollection', domainClass: 'DataTagLinkDomain'}
        });

        OrgMixin(DataTagDomain);

        // more methods go here;

        DataTagDomain.create = create;
        DataTagDomain.update = update;
        DataTagDomain.tagInstance = tagInstance;
        DataTagDomain.tag = tag;
        DataTagDomain.unTagInstance = unTagInstance;
        DataTagDomain.unTag = unTag;

        DataTagDomain.prototype.toString = toString;

        function create(tag) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

          const rootState = $ngRedux.getState();
          const userId = getId(getUser(rootState));
          const request = {
            method: 'data-tags/create',
            name: tag.name,
            description: tag.description,
            form: getLink(tag, 'form').id,
            appliesTo: tag.appliesTo,
            orgId: getLink(tag, 'organization').id
          };

          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC).then(function (response) {
            if (response.statusCode === 200) {
              return DataTagDomain.$get(response.dataTagId)
            }
          });
        }

        function update(tag) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

          const rootState = $ngRedux.getState();
          const userId = getId(getUser(rootState));
          const request = DomainUtils.serializeUpdate('data-tags/update', tag);

          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        function tagInstance(taggable, tags) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});
          return tag(DomainUtils.asDomainLink(taggable), tags);
        }

        /**
         * Add the list of tags to the taggable instance
         * @param {DomainLink} taggable
         * @param {Array.<string>} tags
         */
        function tag(taggable, tags) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});
          const rootState = $ngRedux.getState();
          const userId = getId(getUser(rootState));
          const request = {
            method: 'data-tags/link',
            orgId: getId(getOrganization(rootState)),
            taggable: taggable,
            tags: tags
          };
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        function unTagInstance(taggable, tags) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});
          return unTag(DomainUtils.asDomainLink(taggable), tags);
        }

        /**
         * Remove the list of tags from the taggable instance
         * @param {DomainLink} taggable
         * @param {Array.<string>} tags
         */
        function unTag(taggable, tags) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});
          const rootState = $ngRedux.getState();
          const userId = getId(getUser(rootState));
          const request = {
            method: 'data-tags/unlink',
            orgId: getId(getOrganization(rootState)),
            taggable: taggable,
            tags: tags
          };
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        function toString() {
          return this.name;
        }

        function _getTagLinkId(dataTagId, taggableId) {
          return dataTagId && taggableId ? dataTagId + taggableId : null;
        }

        return DataTagDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/data-tags/domain/DataTagDomain.js